import { useRouter } from 'next/router';
import { createContext, useState, useEffect, useContext } from 'react';

const HistoryContext = createContext();

export const HistoryProvider = ({ children }) => {
	const { asPath, push, pathname } = useRouter();
	const [history, setHistory] = useState([]);
	const [selectedItem, setSelectedItem] = useState(false);

	function back(fallbackRoute) {
		if (history.length <= 1) {
			if (fallbackRoute) {
				push(fallbackRoute);
			} else {
				window.history.back();
			}
			return;
		}

		for (let i = history.length - 2; i >= 0; i--) {
			const route = history[i];
			if (!route.includes('#') && route !== pathname) {
				push(route);
				const newHistory = history.slice(0, i);
				setHistory(newHistory);
				return;
			}
		}

		if (fallbackRoute) {
			push(fallbackRoute);
		} else {
			window.history.back();
		}
	}

	useEffect(() => {
		setHistory((previous) => [...previous, asPath]);

		if (pathname === '/overview') {
			setSelectedItem(false);
		}
	}, [asPath]);

	return (
		<HistoryContext.Provider
			value={{
				back,
				history,
				setHistory,
				pathname,
				selectedItem,
				setSelectedItem,
			}}
		>
			{children}
		</HistoryContext.Provider>
	);
};

export function useHistory() {
	const context = useContext(HistoryContext);
	return context;
}
